module.exports = __webpack_public_path__ + "img/ticket_blue.2f5c352d.svg";